class Entity {
  constructor(
    editor,
    eid,
  ) {
    this.editor = editor;
    this.eid = eid;
  }

  getField = (field) => this.editor.getField(this.eid, `field_${field}`);
}

export default Entity;
